import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Cookie, X } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consentTs = localStorage.getItem("cookie_consent");
    if (!consentTs) {
      const timer = setTimeout(() => setVisible(true), 1200);
      return () => clearTimeout(timer);
    }
    // Re-show after 90 days
    const accepted = parseInt(consentTs, 10);
    if (Date.now() - accepted > 90 * 24 * 60 * 60 * 1000) {
      localStorage.removeItem("cookie_consent");
      const timer = setTimeout(() => setVisible(true), 1200);
      return () => clearTimeout(timer);
    }
  }, []);

  const accept = () => {
    localStorage.setItem("cookie_consent", String(Date.now()));
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: 80, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 80, opacity: 0 }}
          transition={{ type: "spring", damping: 25, stiffness: 300 }}
          className="fixed bottom-4 left-4 right-4 sm:left-auto sm:right-6 sm:bottom-6 sm:max-w-sm z-50"
          data-testid="cookie-banner"
        >
          <div className="bg-[var(--bg-card)] border border-[var(--border-strong)] rounded-xl p-4 shadow-lg backdrop-blur-xl">
            <div className="flex items-start gap-3">
              <div className="shrink-0 mt-0.5">
                <Cookie size={20} weight="duotone" className="text-[#FF4400]" />
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm text-[var(--text-secondary)] leading-relaxed">
                  We use essential cookies to keep you signed in.{" "}
                  <Link to="/legal/privacy" className="text-[#FF4400] hover:underline">
                    Privacy policy
                  </Link>
                </p>
                <div className="flex items-center gap-2 mt-3">
                  <Button
                    onClick={accept}
                    className="h-8 px-4 text-xs font-semibold bg-[#FF4400] hover:bg-[#FF6633] text-white rounded-md transition-all duration-200"
                    data-testid="cookie-accept-button"
                  >
                    Got it
                  </Button>
                  <button
                    onClick={accept}
                    className="h-8 w-8 flex items-center justify-center rounded-md text-[var(--text-muted)] hover:text-[var(--text-secondary)] hover:bg-[var(--bg-elevated)] transition-colors"
                    aria-label="Dismiss"
                    data-testid="cookie-dismiss-button"
                  >
                    <X size={14} />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
